import React, {useRef, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import ShowSnackbar from "../utils/ShowSnackbar";
import {CustomBackdrop} from "../utils/customStyles";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import {Transition} from "../users/OrganizationUserAddDialog";



const paperPropsStyle = {
    minWidth: '400px',
    minHeight: '200px',
    borderRadius: '12px'
}



export default function HispsDeleteDialog(props) {

    const deleteHispDialogOpen = props.deleteHispDialogOpen;
    const setDeleteHispDialogOpen = props.setDeleteHispDialogOpen;
    const hisp = props.hisp;
    const setRefresh = props.setRefresh;
    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''});

    const handleClose = () => {
        setDeleteHispDialogOpen(false);
    };
    const handleSubmit = async (event) => {
        setLoading(true);
        event.preventDefault();
        const url = ApiUrl.Hisps.deleteHisp.getPath(hisp.hispId);

        const requestOption = {
            method: 'DELETE',
            body: ''
        }
        setDeleteHispDialogOpen(false);

        try {
            const res = await fetch(url, requestOption);
            const data = await handleHttpResponse(res);
            console.info(data);
            setSnackbarMsg({open: true, msg: 'Successfully delete HISP: ' + hisp.hispName, msgLv: 'success'});
            setRefresh(new Date().getTime());
        } catch (err) {
            console.error(`Failed to delete HISP: ${hisp.hispName}. ` + err);
            setSnackbarMsg({open: true, msg: `Failed to delete HISP: ${hisp.hispName}`, msgLv: 'error'});
        } finally {
            setLoading(false);
        }
    }


    return (
        <div>
            <Dialog
                open={deleteHispDialogOpen}
                onClose={handleClose}
                PaperProps={{ style: paperPropsStyle}}
                TransitionComponent={Transition}
            >
                <DialogTitle color="white"
                             sx={{backgroundColor: "rgba(60,120,185,1)"}}
                >
                    Confirm Delete
                </DialogTitle>
                <DialogContent>
                    <Typography fontWeight='bold' margin='12px 0px 12px 0px'>
                        {`Please confirm you wish to delete ${hisp.hispId}`}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <div style={{ marginBottom: '10px', marginRight: '10px', display: 'flex', gap: '10px'}}>
                        <Button onClick={handleSubmit} variant='contained'>
                            Delete
                        </Button>
                        <Button onClick={handleClose} autoFocus variant='outlined'>Cancel</Button>
                    </div>
                </DialogActions>
            </Dialog>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <CustomBackdrop open={loading} />
        </div>
    )
}